import { ColumnConfigType } from 'shared/types';
import { BonusesColumnType, ObjectivesType, ParticipantPromoId, PromoB2BTableData } from 'entities/promo/types';

export const fieldsMechanicsConfig: ColumnConfigType<ObjectivesType>[] = [
  {
    dataFieldName: 'id',
    name: 'ID',
    width: '10%',
  },
  {
    dataFieldName: 'name',
    name: 'Название механики',
    width: '100%',
  },
];

export const fieldsParticipantsConfig: ColumnConfigType<ParticipantPromoId>[] = [
  {
    dataFieldName: 'id',
    name: 'ID',
    width: '5%',
  },
  {
    dataFieldName: 'door_code',
    name: 'Код двери',
    width: '20%',
  },
  {
    dataFieldName: 'title',
    name: 'Наименование участника',
    width: '75%',
  },
];

export const fieldsBonusConfig: ColumnConfigType<BonusesColumnType>[] = [
  {
    dataFieldName: 'id',
    name: 'ID',
    width: '5%',
  },
  {
    dataFieldName: 'amount',
    name: 'Количество бонусов',
    width: '5%',
  },
  {
    dataFieldName: 'uid',
    name: 'Код двери',
    width: '5%',
  },
  {
    dataFieldName: 'name',
    name: 'Наименование ТТ',
    width: '40%',
  },
];

export const fieldPromoB2BConfig: ColumnConfigType<PromoB2BTableData>[] = [
  {
    dataFieldName: 'id',
    name: 'ID',
    width: '5%',
  },
  {
    dataFieldName: 'promoName',
    name: 'Промо-акция',
    width: '10%',
  },
  {
    dataFieldName: 'typePromo',
    name: 'Тип акции',
    width: '10%',
  },
  {
    dataFieldName: 'registrationRange',
    name: 'Период регистрации',
    width: '20%',
  },
  {
    dataFieldName: 'activeRange',
    name: 'Период активности',
    width: '20%',
  },
  {
    dataFieldName: 'accessBonusRang',
    name: 'Период доступа бонусов',
    width: '20%',
  },
];
